var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProviderCallOutline = function SvgProviderCallOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#4A657B",
    strokeWidth: 1.424
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.782 19.266s5.311 5.004 8.304 3.426c0 0 .827-.7.908-1.386.08-.688-.608-1.148-.873-1.305-.636-.377-1.29-.728-1.939-1.085-.205-.113-.427-.241-.67-.179-.14.037-.284.078-.412.14-.457.222-.831.43-1.326.639 0 0-.505-.153-2.39-1.924-2.001-1.882-1.73-2.581-1.73-2.581.26-.343.497-.702.694-1.08.085-.164.201-.321.25-.499.05-.178-.052-.306-.139-.462-.192-.35-.397-.694-.61-1.034-.366-.587-.74-1.2-1.209-1.724-.05-.054-.164-.218-.258-.212-1.041.065-2.066 1.032-2.066 1.032-1.611 2.734 3.466 8.234 3.466 8.234z",
    transform: "translate(-11 -8) rotate(5 18.5 16.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProviderCallOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/provider-call-outline.cc50c2557abae35726f0e7d507250bf8.svg";